import { Component as ErrorComponent } from 'components/common-form/sidePanel/status/error/Error.status';
import { StatusLabel } from 'components/common-form/sidePanel/status/initialized/StatusLabel';
import { FC } from 'react';
import type { ProductModificationStatus } from 'state/productModificationForm';

import { connectError } from './ErrorStatus.connect';
import { PendingStatus } from './PendingStatus';
import { ProductModificationDoneComponent } from './productModification.done';
import { RejectedStatus } from './RejectedStatus';
import type { StatusProps } from './status.connect';
import { connectStatus } from './status.connect';

const InitializedStatus: FC = () => (
  <StatusLabel labelKey="productModification.sidePanel.status.initialized" color="secondary" />
);
InitializedStatus.displayName = 'Initialized';

const ReadyStatus: FC = () => <StatusLabel labelKey="productModification.sidePanel.status.ready" color="info" />;
ReadyStatus.displayName = 'Ready';

const ErrorStatus = connectError(ErrorComponent);
ErrorStatus.displayName = 'Failed';

function componentForStatus(status: ProductModificationStatus, hasErrors: boolean, isReady: boolean) {
  switch (status) {
    case 'INITIALIZED':
      if (isReady) {
        return ReadyStatus;
      } else {
        return InitializedStatus;
      }
    case 'PENDING':
      return PendingStatus;
    case 'SUCCESS':
      if (hasErrors === true) {
        return RejectedStatus;
      } else {
        return ProductModificationDoneComponent;
      }
    case 'FAILED':
      return ({ tabId }: { tabId: string }) => <ErrorStatus tabId={tabId} workspaceType="postTrade" />;
  }
}

const StatusComponent: FC<StatusProps> = ({ tabId, status, hasErrors, isReady }) => {
  const Comp = componentForStatus(status, hasErrors, isReady);

  return (
    <div id="side-panel-status" data-e2e="side-panel-status">
      {Comp !== null && <Comp tabId={tabId} />}
    </div>
  );
};

StatusComponent.displayName = 'Status';

export const Status = connectStatus(StatusComponent);
